module.exports = __webpack_public_path__ + "img/Z81_18.43c3f1d6.jpg";